import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

import { SUPPORTED_COUNTRIES } from '@store';

import { NO_VALUE } from '../dash/dash.pipe';

@Pipe({
  name: 'country',
  standalone: true,
})
export class CountryPipe implements PipeTransform {
  constructor(private translateService: TranslateService) {}

  transform(countryCode = ''): string {
    countryCode = countryCode.toLowerCase();
    const country = SUPPORTED_COUNTRIES.find((c) => c.countryCode === countryCode);
    if (country) {
      return this.translateService.instant(country.country);
    } else if (countryCode) {
      return countryCode;
    } else {
      return NO_VALUE;
    }
  }
}
